module.exports = __webpack_public_path__ + "static/media/rank-a.9bf4d059.png";